<template>
  <AcisoForm
    :ref="modal_id"
    modal
    :panel_id="modal_id"
    :panel_title="modal_title"
    :read_only="current_operation === 'view'"
    @cancel="cancelled"
    @submit="submit()"
  >
    <NdsMarkdownViewer
      v-if="policy_password"
      :value="policy_password"
    />
    <form :data-vv-scope="scope">
      <FormField
        v-model="current_obj.password"
        v-validate="{ required: true }"
        data-testid="change-pwd-current"
        :error="errors.first(scope + '.password')"
        :label="_('Current password') + ' *'"
        name="password"
        type="password"
      />

      <FormField
        ref="new_password"
        v-model="current_obj.new_password"
        v-validate="{ required: true, 'password-validator': true, max: 128 }"
        data-testid="new-pass"
        :error="errors.first(scope + '.new_password')"
        :label="_('New password') + ' *'"
        name="new_password"
        type="password"
      />

      <FormField
        v-model="current_obj.new_password_confirm"
        v-validate="'required|confirmed:new_password'"
        data-testid="new-pass-confirmation"
        data-vv-as="new_password"
        :error="errors.first(scope + '.new_password_confirm')"
        :label="_('Confirm new password') + ' *'"
        name="new_password_confirm"
        type="password"
      />
    </form>
  </AcisoForm>
</template>

<script>
import FormField from '@/components/ui/FormField.vue'
import EditMixin from '@/mixins/EditMixin'
import AcisoForm from '@/components/layout/AcisoForm.vue'
import { config } from '@/config.settings'
import NdsMarkdownViewer from '@/components/NewDesignSystem/NdsMarkdown/NdsMarkdownViewer.vue'

export default {
  name: 'UserPasswordModal',
  components: {
    NdsMarkdownViewer,
    AcisoForm,
    FormField,
  },
  mixins: [EditMixin],
  data: function () {
    return {
      current_obj: {
        password: '',
        new_password: '',
        new_password_confirm: '',
        scope: 'form_user_password',
      },
      policy_password: '',
    }
  },
  computed: {
    modal_edit_title: function () {
      return this._('Change password')
    },
  },
  mounted() {
    this.registerValidator('password-validator', 'user/check_password')
    this.$http.get(config.base_url + '/user/password_policy').then((resp) => {
      if (resp.data.ok) {
        this.policy_password = resp.data.object
      } else {
        throw new Error()
      }
    })
  },
}
</script>
